import {
  slab, wallZ, wallX, goal, sign, neon, checkpoint, edgeLights, pad, speedgate,
} from '../kit.js';

/**
 * Speed gates. Each only passes a body moving faster than its number, and
 * every segment offers two ways to earn it: the pad (safe, tuned to clear
 * the gate and land on the far deck) or the drop-pit fling (faster, and
 * where the record lives). Momentum is the toll, and the toll goes up.
 *
 * Segment anatomy: an approach deck, an open shaft mouth between the decks
 * (the shaft's side-wall tops are rim bridges for walking around), a
 * portalable pit floor, and an exit wall on the far deck's rim whose north
 * face fires down-course. Decks meet at a small step so a blocked walker is
 * never stranded over a void.
 */

const segment = (z, y, depth, southD = 24) => [
  slab(0, y, z + 8 + southD / 2, 28, southD, 'plate', 1.4),
  ...edgeLights(0, y, z + 8 + southD / 2, 28, southD, 'amber'),
  slab(0, y, z - 21, 28, 26, 'plate', 1.4),
  ...edgeLights(0, y, z - 21, 28, 26, 'amber'),
  // the shaft: side-wall tops double as rim bridges around the mouth
  wallZ(0, y - depth, z + 8.75, 15, depth, 'plate', 1.5),
  wallZ(0, y - depth, z - 8.75, 15, depth, 'plate', 1.5),
  wallX(-7.75, y - depth, z, 16, depth, 'plate', 1.5),
  wallX(7.75, y - depth, z, 16, depth, 'plate', 1.5),
  slab(0, y - depth, z, 14, 16, 'panel', 1.5),
  neon(0, y - depth + 0.6, z, [13, 0.14, 0.14], 'magenta'),
  // exit wall on the far deck's rim; its far face fires down-course
  wallZ(0, y, z - 10, 15, 10, 'panel', 1.4),
  neon(0, y + 10.4, z - 10.7, [15, 0.14, 0.14], 'cyan'),
];

export default {
  id: 'turbine',
  name: 'TURBINE',
  blurb: 'Momentum is the toll. It goes up.',
  mode: { type: 'gauntlet', limit: 100, par: 26 },
  redline: { seconds: 21 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  // Spawned in the east lane: the straight-ahead walk goes down the deck,
  // and the pit is a visible choice to the left, not a spawn-line ambush.
  spawn: { p: [11, 0.4, 26], yaw: 0 },
  killY: -140,
  env: {
    fog: 0x24140a,
    fogDensity: 0.0042,
    sky: { zenith: 0x100504, horizon: 0x38180c, glow: 0xc25a10, aurora: 0xd88a2a },
    floorY: -280,
  },
  objects: [
    // ---- segment A: pit 42m deep, gate demands 25
    ...segment(0, 0, 42),
    checkpoint(0, 0, 26),
    sign(0, 3.4, 22, 0, ['TURBINE', 'GATES CHARGE A SPEED TOLL', 'THE PIT PAYS IT'], '#d88a2a'),
    sign(0, 2.6, -16, 180, ['TURN AROUND', 'THAT WALL FACES THE COURSE'], '#2ff3ff'),
    pad(10.5, 0, 14, 42, [0, 0.5, -0.87]),
    speedgate(0, -4, -37, 28, 16, 25),

    // ---- segment B: 56m, gate 38
    ...segment(-70, -4, 56, 32),
    checkpoint(0, -4, -44),
    pad(10.5, -4, -56, 52, [0, 0.42, -0.91]),
    speedgate(0, -8, -107, 28, 16, 38),

    // ---- segment C: 74m, gate 50
    ...segment(-140, -8, 74, 32),
    checkpoint(0, -8, -114),
    pad(10.5, -8, -126, 58, [0, 0.38, -0.925]),
    speedgate(0, -12, -177, 28, 20, 50),

    // ---- home stretch
    slab(0, -12, -212, 34, 80, 'plate', 1.6),
    ...edgeLights(0, -12, -212, 34, 80, 'lime'),
    wallZ(0, -12, -252.8, 36, 20, 'plate', 1.6),
    checkpoint(0, -12, -196),
    goal(0, -12, -226, 0),
  ],
};
